<script setup lang="ts"></script>

<template>
  <NuxtLinkLocale
    to="https://t.me/Banks_KG"
    target="_blank"
    class="relative block overflow-hidden rounded-lg bg-gradient-to-br from-[#0395DE] to-[#0496E3] p-4 text-white transition-all duration-500 ease-out hover:from-[#38bdf8] hover:to-[#0ea5e9]"
  >
    <!-- Desktop background -->
    <NuxtImg
      src="/images-backup/about/phone_bg.png"
      alt="Background"
      class="absolute bottom-0 right-0 hidden object-contain transition-opacity duration-300 sm:block"
      width="150"
      height="150"
      format="avif,webp"
      quality="85"
      loading="lazy"
    />
    <!-- Mobile background -->
    <NuxtImg
      src="/images-backup/about/phone_mobile_bg.png"
      alt="Background Mobile"
      class="absolute bottom-0 right-0 z-0 object-contain transition-opacity duration-300 sm:hidden"
      width="290"
      height="137"
      format="avif,webp"
      quality="85"
      loading="lazy"
    />
    <div class="relative z-10">
      <!-- Logo And Nickname (For Mobile) -->
      <div class="mb-3 flex items-center justify-between sm:hidden">
        <NuxtImg src="/images-backup/logos/logo-white.png" alt="Logo" width="70" height="26" />
        <div class="flex items-center gap-2.5">
          <div class="flex h-5 w-5 items-center justify-center rounded-full bg-white">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="#0395DE"
              xmlns="http://www.w3.org/2000/svg"
              class="size-3"
            >
              <path
                d="M22.9373 5.45659L19.6174 19.0342C19.3669 19.9924 18.7137 20.2309 17.7855 19.7795L12.727 16.5469L10.2862 18.5827C10.0161 18.817 9.79016 19.0129 9.26958 19.0129L9.633 14.5452L19.0084 7.19851C19.416 6.88334 18.92 6.70873 18.3749 7.02389L6.78454 13.3527L1.7948 11.9984C0.70944 11.7045 0.689795 11.0571 2.02072 10.6057L21.5376 4.0852C22.4413 3.79134 23.232 4.25982 22.9373 5.45659Z"
              />
            </svg>
          </div>
          <span class="text-sm font-bold">@Banks_KG</span>
        </div>
      </div>

      <!-- Logo (For Desktop) -->
      <NuxtImg
        src="/images-backup/logos/logo-white.png"
        alt="Logo"
        class="mb-3 hidden sm:block"
        width="86"
        height="32"
      />

      <h3
        class="z-10 max-w-40 text-base font-bold leading-tight sm:mb-6 sm:max-w-full sm:text-xl xl:max-w-52"
      >
        {{ $t('widget.telegram.title') }}
      </h3>

      <!-- Nickname (For Desktop) -->
      <div class="mb-4 hidden items-center gap-2.5 sm:flex">
        <div class="flex h-5 w-5 items-center justify-center rounded-full bg-white">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="#0395DE"
            xmlns="http://www.w3.org/2000/svg"
            class="size-3"
          >
            <path
              d="M22.9373 5.45659L19.6174 19.0342C19.3669 19.9924 18.7137 20.2309 17.7855 19.7795L12.727 16.5469L10.2862 18.5827C10.0161 18.817 9.79016 19.0129 9.26958 19.0129L9.633 14.5452L19.0084 7.19851C19.416 6.88334 18.92 6.70873 18.3749 7.02389L6.78454 13.3527L1.7948 11.9984C0.70944 11.7045 0.689795 11.0571 2.02072 10.6057L21.5376 4.0852C22.4413 3.79134 23.232 4.25982 22.9373 5.45659Z"
            />
          </svg>
        </div>
        <span class="text-sm font-bold">@Banks_KG</span>
      </div>
    </div>
  </NuxtLinkLocale>
</template>

